import { z } from 'zod';
import { VehicleSchema } from '../vehicle';

const classification = VehicleSchema.model.shape.classification.shape;
const registration = VehicleSchema.model.shape.registration.shape;

export const driverVehicleSchema = VehicleSchema.model
  .pick({
    _id: true,
    status: true,
    org: true,
  })
  .extend({
    plate: registration.plate,
    country: registration.country,
    year: classification.year,
    type: classification.type,
    group: classification.group,
  });
export type DriverVehicle = z.infer<typeof driverVehicleSchema>;
